import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple"> Olympiah </span>
            from <span className="purple"> Nairobi, Kenya.</span>
            <br />I hold a Bsc. in Computer Science 
            <br />
            <br />
            Apart from coding, some of my hobbies include:
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Travelling 
            </li>
            <li className="about-activity">
              <ImPointRight /> Giving back to the community
            </li>
            <li className="about-activity">
              <ImPointRight /> Recreating authentic cultural dishes
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "I aspire to help build robust and user-centric solutions!"{" "}
          </p>
          <footer className="blockquote-footer">Olympiah</footer>
        </blockquote>
        
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
